import { AxiosInstance } from "axios";
import React from "react";

export interface RpiApiContextProps {
  graphqlClient: AxiosInstance;
  headers?: Record<string, string> | (() => Record<string, string> | Promise<Record<string, string>>);
}

export const RpiApiContext = React.createContext<RpiApiContextProps | null>(null);

export const RpiApiProvider = RpiApiContext.Provider;

export function useRpiApiContext() {
  const rpiApiContext = React.useContext(RpiApiContext);
  if (!rpiApiContext) {
    throw new Error("useRpiApiContext must be used within a RpiApiProvider");
  }

  return rpiApiContext;
}
